import * as React from "react";

import { Head } from "../components/seo/head";
import { Main } from "../components/layout/main";
import { Nav } from "../components/layout/nav";
import { Root } from "../components/layout/root";
import { Join } from "../components/join";
import { Footer } from "../components/layout/footer";

export interface LayoutProps {
  title: string;
  description?: string;
  isNavWhite?: boolean;
  children: JSX.Element | JSX.Element[];
  joinLink?: { to: string; text: string };
  navCta?: { to: string; text: string };
  noHeaderAndFooter?: boolean;
  slug?: string;
  norobots?: boolean;
}

const Layout = ({
  children,
  title,
  description,
  isNavWhite,
  joinLink,
  navCta,
  noHeaderAndFooter,
  slug,
  norobots,
}: LayoutProps) => (
  <Root>
    <Head
      title={title}
      description={description}
      slug={slug}
      norobots={norobots}
    />
    {!noHeaderAndFooter ? (
      <>
        <Nav isNavWhite={isNavWhite} navCta={navCta} />
      </>
    ) : null}
    <Main>
      {children}
      {!noHeaderAndFooter ? <Join link={joinLink} /> : null}
    </Main>
    {!noHeaderAndFooter ? <Footer /> : null}
    <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/43852795.js"></script>
  </Root>
);

export { Layout };
